import React, { Component } from 'react';

class Impressum extends Component {
  render() {
    return (
      <article className="your-container">
        <div className="row">
          <header className="col-md-10 col-md-offset-1 text-center section-header">
            <h1>Impressum</h1>
          </header>
        </div>
        <div className="row">
          <section className="col-md-10 col-md-offset-1 text-center">
            <p>Angaben gemäß § 5 TMG:</p>

            <p>
              Südstadt Leben e.V.<br />
              Martin Luther-Platz 2-4 <br />
              50677 Köln <br />
              <br />
            </p>
            <h3>Kontakt:</h3>
            <p>
              Telefon 0221 / 38 44 63 <br />
              E-Mail lutherkirche@suedstadt-leben-koeln.de <br />
              <br />
            </p>

            <h3>Urheberrechtsnachweise:</h3>

            <p>
              Startseite (Header-Bild): Fotograf Puchthoo Live ID #125001550
            </p>

            <p>
              Wünsche-Seite (Avatare): Die Avatare wurden generiert unter
              Copyright (c) 2014 Adorable IO LLC
            </p>
          </section>
        </div>
      </article>
    );
  }
}

export default Impressum;



// WEBPACK FOOTER //
// ./src/Containers/Pages/Impressum.js